import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import BullionConfigApi from 'api/bullionconfig';
import { BullionConfigValidationSchema } from 'formValidations/bullionConfigFormValidations';
import { MetalTypesOptions } from 'config/constant';

const PopModal = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const initialValues = {
    type: 'GOLD22KT',
    unit: 'gm',
    customer_max_buy: '',
    customer_max_sell: '',
    buy_price_percentage_deviation: '',
    sell_price_percentage_deviation: '',
    exchange_price_percentage_deviation: '',
    threshold_buy: '',
    threshold_sell: '',
  };

  const handleSubmit = async (values, actions) => {
    try {
      const api = await BullionConfigApi.Create(values);
      if (api.data.status_code === 200) {
        toast({
          title: api?.data?.message || 'Successfully Added',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: api?.data?.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toast({
        title: err?.response?.data?.message || 'Error occurred',
        status: 'error',
        duration: 1000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        py='5px'
        disabled={props.disabled}
        onClick={onOpen}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={BullionConfigValidationSchema}
              onSubmit={handleSubmit}>
              {({ isSubmitting }) => (
                <Form noValidate>
                  <Flex
                    justifyContent='space-between'
                    gap={5}>
                    <SelectField
                      label='type'
                      name='type'
                      options={MetalTypesOptions}
                      required
                    />
                    <InputField
                      label='Unit'
                      name='unit'
                      type='text'
                      variant='auth'
                      defaultValue='gm'
                      disabled
                    />
                  </Flex>
                  <InputField
                    label='Sell Price Percentage Deviation'
                    name='sell_price_percentage_deviation'
                    type='number'
                    placeholder='Sell Price Percentage Deviation'
                    required
                  />
                  <InputField
                    label='Buy Price Percentage Deviation'
                    name='buy_price_percentage_deviation'
                    type='number'
                    placeholder='Buy Price Percentage Deviation'
                    required
                  />
                  <InputField
                    label='Exchange Price Percentage Deviation'
                    name='exchange_price_percentage_deviation'
                    type='number'
                    placeholder='Exchange Price Percentage Deviation'
                    required
                  />
                  <InputField
                    label='Max Buy Limit'
                    name='customer_max_buy'
                    type='number'
                    placeholder='Max Buy Limit'
                    required
                  />
                  <InputField
                    label='Max Sell Limit'
                    name='customer_max_sell'
                    type='number'
                    placeholder='Max Sell Limit'
                    required
                  />
                  <InputField
                    label='Sell Threshold'
                    name='threshold_sell'
                    type='number'
                    placeholder='Sell Threshold'
                    required
                  />
                  <InputField
                    label='Buy Threshold'
                    name='threshold_buy'
                    type='number'
                    placeholder='Buy Threshold'
                    required
                  />
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}>
                      Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PopModal;
